/* eslint prefer-template:0,no-extra-parens:0,func-style:0 */

import isLocal from '../common/isLocal.js'
import joinURL from '../common/joinURL.js'

export default function (window, versions, getPloaderSantaConfig) {
  function getEditorRjsConfig(serviceTopology, editorModel, baseVersion, PackagesUtil) { // eslint-disable-line no-unused-vars
    const langsLocation = serviceTopology && serviceTopology.scriptsLocationMap['santa-langs'] || 'http://static.parastorage.com/services/santa-langs/1.194.0'
    const languageCode = editorModel && editorModel.languageCode || 'en'
    let langsUrl = joinURL(langsLocation, 'resources/santa-editor/bundles/_generated/santa_editor_' + languageCode + '.json')
    if (langsUrl.indexOf('http:') === 0) {
      langsUrl = [langsUrl, langsUrl.replace(/http/, 'https')]
    }

    const tpaGfppDataUrl = serviceTopology && serviceTopology.scriptsLocationMap['tpa-gfpp-data'] || 'http://static.parastorage.com/services/tpa-gfpp-data/1.5.0'
    const mmgrBaseUrl = serviceTopology ? serviceTopology.mediaManagerUrl : 'http://editor.wix.com/static/services/media-gallery-g5/1.81.0/'
    const scriptLocation = (serviceTopology && serviceTopology.scriptsDomainUrl) || 'http://static.parastorage.com/'
    const thirdParty = joinURL.bind(null, scriptLocation, 'services', 'third-party')
    const ckeditor = joinURL.bind(null, scriptLocation, 'services', 'ck-editor')

    const basePublicUrl = serviceTopology.basePublicUrl || 'http://www.wix.com'
    const santaIde = joinURL.bind(null, basePublicUrl, '_partials', 'santa-ide')

    const getIntegrationPath = function (app) {
      const packageName = app + 'IntegrationEditor'
      if (isLocal(window.editorBase)) {
        return 'http://localhost:4578/' + packageName + '/src/main'
      }
      return 'http://s3.amazonaws.com/integration-tests-statics/SNAPSHOT/runners/' + packageName + '/src/main'
    }

    return {
      baseUrl: '',
      paths: {
        lodash: thirdParty(`lodash/${versions.lodash}/lodash.min`),
        jquery: thirdParty('jquery/2.1.1/dist/jquery.min'),
        zepto: thirdParty('zepto/1.2.0/zepto.min'),
        ckeditor: ckeditor('1.223.0/ckeditor'),
        wixmp: joinURL(serviceTopology.scriptsLocationMap['wixmp-sdk'], 'wixmp-sdk.amd'),
        color: thirdParty('color-convert/0.2.0/color.min'),
        speakingurl: thirdParty('speakingurl/speakingurl.min'),
        keyboardMaster: {
          min: thirdParty('keymaster/1.6.3/keymaster.min'),
          source: thirdParty('keymaster/1.6.3/keymaster')
        },
        react: {
          min: thirdParty(`react/${versions.react}/react-with-addons.min`),
          source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-with-addons`
        },
        reactDOM: {
          min: thirdParty(`react/${versions.react}/react-dom.min`),
          source: `//cdnjs.cloudflare.com/ajax/libs/react/${versions.react}/react-dom`
        },
        langs: langsUrl,
        mediaFrame: joinURL(mmgrBaseUrl, 'scripts/media-frame'),
        aviary: thirdParty('aviary/3.1.0.243/js/feather'),
        facebook: ['//connect.facebook.net/en_US/all', 'js/vendor/facebook/facebook.min'],
        pms: 'js/modules/PMS',
        jasmine: thirdParty('jasmine/2.1.3/jasmine'),
        'jasmine-html': thirdParty('jasmine/2.1.3/jasmine-html'),
        'jasmine-boot': thirdParty('jasmine/2.1.3/jasmine-boot'),
        bluebird: thirdParty('bluebird/2.9.4/bluebird.min'),
        plugins: 'js/plugins/bundle/plugins.bundle',
        santaIde: {
          min: santaIde(`${versions.santaIde}/code_edit/built-codeEdit.min`),
          source: santaIde(`${versions.santaIde}/code_edit/built-codeEdit`)
        },
        redux: {
          min: thirdParty('redux/3.0.5/redux.min'),
          source: thirdParty('redux/3.0.5/redux')
        },
        'react-redux': {
          min: thirdParty('react-redux/4.4.5/react-redux.min'),
          source: thirdParty('react-redux/4.4.5/react-redux')
        },
        'redux-immutablejs': thirdParty('redux-immutablejs/0.0.7/redux-immutablejs.min'),
        immutable: {
          min: thirdParty('immutable/3.7.5/dist/immutable.min'),
          source: thirdParty('immutable/3.7.5/dist/immutable')
        },
        ReactProxy: 'js/vendor/ReactProxy',
        io: 'https://cdnjs.cloudflare.com/ajax/libs/socket.io/1.4.0/socket.io.min',
        hot: '../node_modules/santa-utils/common/hot/listener',
        'wix-fullstory-loader': './node_modules/wix-fullstory-loader/dist/statics/app.bundle',
        patcher: '../node_modules/santa-utils/common/hot/patcher',
        pmrpc: thirdParty('pm-rpc/1.0.3/pm-rpc.min'),
        tpaGfppData: joinURL(tpaGfppDataUrl, '/data/tpa-gfpp-data.min'),
        baseUILib: 'node_modules/wix-base-ui/dist/base-ui',
        wixRichText: {
          min: './node_modules/wix-richtext/dist/bundleWixRichText',
          source: './node_modules/wix-richtext/debug/bundleWixRichText'
        },
        TweenMax: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        TweenLite: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        TimelineMax: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/TweenMax.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/TweenMax`) },
        ScrollToPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/ScrollToPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/ScrollToPlugin`) },
        DrawSVGPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/DrawSVGPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/DrawSVGPlugin`) },
        MorphSVGPlugin: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/plugins/MorphSVGPlugin.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/plugins/MorphSVGPlugin`) },
        Draggable: { min: thirdParty(`tweenmax/${versions.tweenmax}/minified/utils/Draggable.min`), source: thirdParty(`tweenmax/${versions.tweenmax}/uncompressed/utils/Draggable`) },
        addPanelSectionsDA: './node_modules/editor-add-panel/dist/addPanelSectionsDA',
        addPanelSectionsDE: './node_modules/editor-add-panel/dist/addPanelSectionsDE',
        addPanelSectionsEN: './node_modules/editor-add-panel/dist/addPanelSectionsEN',
        addPanelSectionsES: './node_modules/editor-add-panel/dist/addPanelSectionsES',
        addPanelSectionsFR: './node_modules/editor-add-panel/dist/addPanelSectionsFR',
        addPanelSectionsIT: './node_modules/editor-add-panel/dist/addPanelSectionsIT',
        addPanelSectionsJA: './node_modules/editor-add-panel/dist/addPanelSectionsJA',
        addPanelSectionsKO: './node_modules/editor-add-panel/dist/addPanelSectionsKO',
        addPanelSectionsNL: './node_modules/editor-add-panel/dist/addPanelSectionsNL',
        addPanelSectionsNO: './node_modules/editor-add-panel/dist/addPanelSectionsNO',
        addPanelSectionsPL: './node_modules/editor-add-panel/dist/addPanelSectionsPL',
        addPanelSectionsPT: './node_modules/editor-add-panel/dist/addPanelSectionsPT',
        addPanelSectionsRU: './node_modules/editor-add-panel/dist/addPanelSectionsRU',
        addPanelSectionsSV: './node_modules/editor-add-panel/dist/addPanelSectionsSV',
        addPanelSectionsTR: './node_modules/editor-add-panel/dist/addPanelSectionsTR',
        coreUtilsLib: 'node_modules/santa-core-utils/dist/coreUtils',
        imageClientApi: 'node_modules/santa-core-utils/dist/imageClientApi',
        wixImmutable: 'node_modules/santa-core-utils/dist/wixImmutable',
        'ag-grid': { min: thirdParty('ag-grid/6.2.1/dist/ag-grid.min'), source: thirdParty('ag-grid/6.2.1/dist/ag-grid') }
      },
      packages: [
        {
          name: 'platformIntegrationEditor',
          main: 'platformIntegrationEditor',
          location: getIntegrationPath('platform')
        }, {
          name: 'uiLibIntegrationEditor',
          main: 'uiLibIntegrationEditor',
          location: getIntegrationPath('uiLib')
        }, {
          name: 'tpaIntegrationEditor',
          main: 'tpaIntegrationEditor',
          location: getIntegrationPath('tpa')
        }
      ],
      bundles: {
        plugins: ['json', 'domReady', 'experiment', 'pLoader']
      },
      shim: {
        color: { exports: 'Color' },
        lodash: { exports: '_' },
        jquery: { exports: '$' },
        keyboardMaster: { exports: 'key' },
        mediaFrame: { exports: 'MediaFrame', deps: ['jquery'] },
        aviary: { exports: 'featherEditor' },
        facebook: { exports: 'FB' },
        'jasmine-html': { deps: ['jasmine'] },
        'jasmine-boot': { deps: ['jasmine', 'jasmine-html'] },
        bluebird: { exports: 'bluebird' },
        ReactProxy: {
          deps: ['react'],
          exports: 'ReactProxy'
        }
      },
      map: {
        '*': {
          'react/addons': 'react'
        }
      },
      pLoader: {
        santa: getPloaderSantaConfig(serviceTopology, baseVersion, PackagesUtil)
      },
      jsx: {
        baseDefines: { lodash: '_', react: 'React' },
        fileExtension: '.html'
      },
      waitSeconds: 0
    }
  }

  return getEditorRjsConfig
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/editor/rjs-config.js